import { NotifyHelper } from "../../../helpers/toast";
import { eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj } from "../../action-types/xet-tot-nghiep/IDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const duDieuKienKetQuaHocTapXetTotNghiepActions = {
    ...generateActions(eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP"),
    ...generateActionForKey(eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP", "LOAD_BY_DOT_XET_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP", "UPDATE_LOCK_STATUS_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
}